module.exports = __webpack_public_path__ + "static/diners-icon-513cd80355c9917b300697ac8ea74768.svg";